import FancyButton from "../Common/FancyButton";

import style from "./style.module.scss";

function FancyButtons() {
    return null;
    return <div className={style.FancyButtons}>
        <div className={style.cnt}>
            <FancyButton middle="Vastgoed Vinder" upper="breng mij naar" lower="klik hier" />
            <FancyButton middle="Gratis Magazine" upper="Ik wil graag een" lower="klik hier" bk="#3e6373" to="/magazine" />
        </div>
    </div>
}

export default FancyButtons;